<template>
  <div class="page flex-col">
    <div class="text-wrapper_2 flex-col">
      <span class="paragraph_1">
        中国（北京）自由贸易试验区
        <br />
        科技创新片区昌平组团简介
      </span>
    </div>
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng3bd4c81d3702978f30ea96a9fe7fd7215a59baf9b1b21e77315138b078ba77fb.png"
    />
    <span class="paragraph_2">
      &nbsp;&nbsp;中国（北京）自由贸易试验区科技创新片区昌平组团（以下简称“昌平组团”）包括生命科学园及周边朱辛庄-七里渠、巩华城等区域，面积约10.26平方公里，于2020年9月27日正式挂牌。
      <br />
      <br />
      &nbsp;&nbsp;昌平组团主要聚焦两大产业：一是医药健康，以生命科学园为核心，目前已基本形成基础研究、中试研发、生产流通、终端医疗的全产业链资源聚集，是北京医药健康产业发展的创新引擎，正在加快建设具有全球领先水平的“生命谷”；二是数字经济，组团内已聚集小米、三一、好未来、慧聪等一批行业龙头企业，在新一代信息技术及其衍生领域率先布局，初步形成高端产业数字化集群发展态势。
      <br />
      <br />
      &nbsp;&nbsp;昌平组团将牢牢抓住“两区”建设的重大历史机遇，努力实现“三个突破”：一是科技创新能力取得新突破。依托国家战略科技力量，实施生命技术赶超工程，努力实现更多“从0到1”的突破，打造生命科学领域原始创新策源地。二是开放发展水平取得新突破。发挥“两区”试验田作用，着力打造“类海外”发展环境，不断提升对国外技术、人才、资本的吸引力，打造全球高端创新资源聚集地。三是产业发展质量取得新突破。瞄准医药健康和数字经济两大方向，进一步引增量、稳存量，加快培育新的优质增长点，打造首都高精尖产业发展新高地。
      <br />
      <br />
      &nbsp;&nbsp;围绕自贸试验区的建设，昌平组团将全力打造开放性、国际化、具有市场活力的高端创新生态。一是强化制度创新。重点推动技创新、人才服务、重点产业、投资便利、金融开放、营商环境六大方面63项创新举措落地，目前公司型创投企业所得税优惠政策试点、技术转让所得税优惠政策试点、自贸试验区昌平组团支持医药健康产业发展暂行办法等一批创新政策已落地。力争在国际研究型医院建设、去中心化临床试验试点、争取北京人遗服务站设立绿色通道等核心任务上率先突破，切实把政策红利传导到企业、落实到项目，尽快形成一批有活力、有实效的制度创新成果。二是优化创新环境。加快推进外国人服务大厅、国际人才活动室、企业综合服务中心、企业集中办公平台搭建，统筹建设“一厅、一室、一中心、一平台”自贸服务体系，精准服务企业和人才。围绕产业发展规律和共性需求，集中布局一批产业服务平台，积极引入CRO、CDMO、CMO等专业服务机构，畅通从基础研究到产业落地的通道。积极引入市场化会议机构，高标准策划招商推介、学术交流等系列活动，支持入园企业建立创新联合体，打造更具“黏性”的生态体系。三是完善基础配套。昌平组团及周边已建成北大国际医院、积水潭医院、清华长庚医院等一批优质医院，正与高瓴资本合作建设500张床位的国际研究型医院；已建成人大附中昌平学校、清华附小昌平学校等13所优质学校，在建、拟建教育配套项目23个，全部引入优质名校办学；已建成地铁昌平线、地铁8号线、市郊铁路S2线，规划建设北部联络线、M19号线。下一步，将加快生命园三期、国际信息产业园等重点区域开发建设，高起点做好城市设计，高标准建设配套设施，解决好企业和人才所关心的配套服务，真正实现产城融合，为各类主体创新创业创造更好的条件。
      <br />
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />